import { render, staticRenderFns } from "./suizhengyongyaoguilv.vue?vue&type=template&id=445571a4&"
import script from "./suizhengyongyaoguilv.vue?vue&type=script&lang=ts&"
export * from "./suizhengyongyaoguilv.vue?vue&type=script&lang=ts&"
import style0 from "./suizhengyongyaoguilv.vue?vue&type=style&index=0&id=445571a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports